'use strict';

import React, { Component, Fragment } from 'react'

import Layout from '@Layout/ECFront'

import HolidaysMessage from '@/HolidaysMessage'

import Loader from '@Pure/Loader'
import Image  from '@Pure/Image'
import Link   from '@Pure/Link'
import Logo   from '@Pure/Logo'

import _ from 'lodash'

const moment = window.moment;

const app = window.app;

export default class MyECInfosPage extends Component
{
	constructor (props)
	{
		super();

		this.state =
		{
			admins: []
		};

		this.handleSessionChange = this.handleSessionChange.bind(this);
	}

	UNSAFE_componentWillMount ()
	{
		const component = this, props = this.props, state = this.state;

		app.resetFunctions();

		app.push(
		{
			event: 'sessionChange',
			cb: component.handleSessionChange
		});

		component.handleSessionChange('MyECInfosPage');
	}

	componentWillUnmount ()
	{
		const component = this, props = this.props, state = this.state;

		app.delete(
		{
			event: 'sessionChange',
			cb: component.handleSessionChange
		});

		component.handleSessionChange();
	}

	handleSessionChange (source)
	{
		const component = this, props = this.props, state = this.state;

		if (app.state.session.EC instanceof Object === false) return;

		component.setState(
		{
			EC: _.cloneDeep(app.state.session.EC)
		});

		qwest.post('/my-EC/my-admins')
		.then(function (xhr, response)
		{
			component.setState(
			{
				admins: response.admins || []
			});
		})
		.catch(function (error, xhr, response)
		{
			app.ajaxRedirectLogin(response);

			console.error(error);
		});
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		let output, loader;

		if (component.state.loading === true)
		{
			loader = <Loader className="c-loader" bemit={ ['primary', 'bg-white'] } />;
		}

		let description, contact;

		if (state.EC)
		{
			description = (state.EC.description || '').split('<p><br></p>').join('');

			description =
			(
				<span dangerouslySetInnerHTML={
					{ __html: description } }></span>
			);

			let business_hours = (state.EC.opening_time || '').split('<p><br></p>').join('');

			if (business_hours)
			{
				business_hours =
				(
					<span dangerouslySetInnerHTML={
						{ __html: business_hours } }></span>
				);
			}

			let address = state.EC.address;

			if (address instanceof Object)
			{
				let city = address.city || '';

				if (address.zip_code) city = ' ' + city;

				address =
				(
					<address className="u-margin-top-15">
						{ address.line_1 }
						{ address.line_2 ? ', ' + address.line_2 : '' }
						<br />
						{ address.zip_code }
						{ city }
					</address>
				);
			}

			contact =
			(
				<Fragment>
					{ business_hours || undefined }
					{ address }
				</Fragment>
			);
		}

		let contact_email;

		if (state.EC && state.EC.email)
		{
			contact_email =
			(
				<Fragment>
					Contact&nbsp;:
					<br />
					<strong>{ state.EC.email }</strong>
				</Fragment>
			);
		}

		let logo;

		if (state.EC && state.EC.logo && state.EC.logo[0])
		{
			logo =
			(
				<Image className="logo-infos" src={ state.EC.logo[0].url } />
			);
		}

		let structure = 'mon CE';

		if (state.EC)
		{
			if (state.EC.type == 'COS')
			{
				structure = 'mon COS';
			}
			else if (state.EC.type == 'CCAS')
			{
				structure = 'mon CCAS';
			}
			else if (state.EC.type == 'CIAS')
			{
				structure = 'mon CIAS';
			}
			else if (state.EC.type == 'Amicale')
			{
				structure = 'mon Amicale';
			}
			else if (state.EC.type == 'Collège partenaire')
			{
				structure = 'mon Collège partenaire';
			}
		}

		let admins = state.admins.map(function (user)
		{
			let output =
			(
				<div className="c-data-row c-data-row--v2" key={ user.id }>

					<li className="o-grid__item c-data-row__item">
						{ user.firstname }
					</li>

					<li className="o-grid__item c-data-row__item">
						{ user.lastname }
					</li>

					<li className="o-grid__item c-data-row__item">
						{ user.email }
					</li>

				</div>
			);

			return output;
		});

		let admins_title;

		if (state.admins.length)
		{
			admins =
			(
				<div className="table-container">

					<div className="c-table">
						<div className="c-data-row c-data-row--v2 c-data-row--header">
							<div className="o-grid__item c-data-row__item">Prénom</div>
							<div className="o-grid__item c-data-row__item">Nom</div>
							<div className="o-grid__item c-data-row__item">E-mail</div>
						</div>

						{ admins }
					</div>

				</div>
			);

			admins_title =
			(
				<div className="c-title">
					<h2 className="c-title__txt">
						Élus de { structure }
					</h2>
				</div>
			);
		}

		let pdf_files = [];

		if (state.EC && Array.isArray(state.EC.pdfs))
		{
			pdf_files = (state.EC.pdfs || [])
			.filter(data => Boolean(data))
			.map(function (file, i)
			{
				let output =
				(
					<div className={ 'u-full-width u-margin-top-' + (i === 0 ? '20' : '10') }
						key={ i }>
						<Link href={ file.url } type="application/pdf" target="_blank">
							{ file.filename }
						</Link>
					</div>
				);

				return output;
			});
		}

		let pdf_files_title;

		if (pdf_files.length > 0)
		{
			pdf_files_title =
			(
				<div className="c-subtitle u-margin-top-30">
					<div className="c-subtitle__txt">
						Pièces jointes
					</div>
				</div>
			);
		}

		output =
		(
			<Layout history={ props.history } page_title="Infos pratiques">

				<div className="page-content">

					<HolidaysMessage />

					{
						app.state.session?.permissions?.title === 'EC' ?
						(
							<Link className="c-btn c-btn--extra
								u-margin-bottom-10"
								href="/espace-administrable/informations-du-CE">
								<svg className="o-svg-icon o-svg-icon--edit c-btn__icon u-margin-right-15">
									<use xlinkHref="/images/icons.svg#svg-icon-edit"></use>
								</svg>
								Modifier les informations
							</Link>

						)
						: undefined
					}

					<div className="c-title u-no-margin-top">
						<h2 className="c-title__txt">
							Présentation
						</h2>
					</div>

					<div className="page-txt">
						<div className="u-negative-margins">

							<div className="o-grid u-items-center">
								<div className="o-grid__item-7">
									{ description }

									{ pdf_files_title }

									{ pdf_files }
								</div>

								<div className="o-grid__item-5 u-text-center">
									{ logo }
								</div>
							</div>

						</div>

					</div>

					<div className="c-title">
						<h2 className="c-title__txt">
							Contact
						</h2>
					</div>

					<div className="page-txt">

						<div className="u-negative-margins">

							<div className="o-grid u-items-center">
								<div className="o-grid__item-5">
									{ contact }
								</div>

								<div className="o-grid__item-7">
									{ contact_email }
								</div>
							</div>

						</div>

					</div>

					{ admins_title }

					{ admins }

				</div> { /* /page-content */ }

			</Layout>
		);

		return output;
	}
}